import {DashboardLayout} from "../../layout/dashboard.layout";
import {useTranslation} from "react-i18next";
import {DASHBOARD} from "../../../routes/frontend.routes";
import {createColumnHelper} from "@tanstack/react-table";
import {IndeterminateCheckbox} from "../../../../app-common/components/input/checkbox.intermediate";
import React from "react";
import {TableComponent} from "../../../../app-common/components/table/table";
import {SENT_BULK_DELETE, SENT_LIST} from "../../../../api/routing/routes/backend.app";
import {Sent} from "../../../../api/model/sent";
import moment from "moment";

export const SentArchive = () => {
  const {t} = useTranslation();
  const columnHelper = createColumnHelper<Sent>();

  const columns = [
    columnHelper.accessor('uuid', {
      enableSorting: false,
      header: ({table}) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: table.getIsAllRowsSelected(),
              indeterminate: table.getIsSomeRowsSelected(),
              onChange: table.getToggleAllRowsSelectedHandler(),
            }}
          />
        </div>
      ),
      cell: ({row}) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: row.getIsSelected(),
              indeterminate: row.getIsSomeSelected(),
              onChange: row.getToggleSelectedHandler(),
            }}
          />
        </div>
      ),
    }),
    columnHelper.accessor('message', {
      header: () => t('Message'),
    }),
    columnHelper.accessor('createdAt.datetime', {
      header: () => t('Created At'),
      cell: info => moment(info.getValue()).format('lll'),
    }),
    columnHelper.accessor('sentAt', {
      header: () => t('Sent At'),
      cell: info => info.getValue() ? moment(info.getValue()).format('lll') : t('Pending')
    }),
    columnHelper.accessor('number', {
      header: () => t('Number'),
    })
  ];

  return (
    <DashboardLayout
      title="Sent Archive"
      breadCrumbs={[
        {title: t('Dashboard'), link: DASHBOARD},
        {title: t('Sent Archive'), current: true}
      ]}
    >
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">{t('List')}</h5>
              <TableComponent columns={columns} url={SENT_LIST} params={{
                isSent: true
              }} sort={[{id: 'createdAt_datetime', desc: true}]} selectionButtons={[{
                title: <i className="bi bi-trash3"></i>,
                type: 'bulkDelete',
                className: 'btn btn-danger',
                url: SENT_BULK_DELETE
              }]}/>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};
